import React, { FC } from "react";
import { useLastUpdated } from "./bookings/hooks";
import { useIsGeorgetownSite } from "./hooks";
import InmateCount from "./counts/components/InmateCount";
import { formatDate } from "./util";

const GEORGETOWN_DISCLAIMER_TEXT = "This web site contains information obtained on individuals who were booked at the Georgetown County Detention Center by the City of Georgetown, Town of Andrews, Town of Pawleys Island and the South Carolina Department of Public Safety (SC Highway Patrol). Georgetown county cannot validate the accuracy of the information and is not responsible for any inaccuracies that may be posted."
// North Myrtle Beach dropped: bookings into the NMB city jail are no longer published here,
// so the disclaimer must stop telling the public that they are.
const HORRY_DISCLAIMER_TEXT = "This website contains information obtained on individuals who were booked at the J. Reuben Long Detention Center, Horry County cannot validate the accuracy of the information and is not responsible for any inaccuracies that may be posted."


const Disclaimer: FC = () => {
  const lastUpdated = useLastUpdated()
  const isGeorgetownSite = useIsGeorgetownSite()

  var disclaimerText = isGeorgetownSite ? GEORGETOWN_DISCLAIMER_TEXT : HORRY_DISCLAIMER_TEXT;

  return (
    <div className="span6">
      <div className="well">
        <h4>Disclaimer:</h4>
        <p>{disclaimerText}</p>
        <div><i className="icon-time"></i> Data last collected @ {formatDate(lastUpdated) || 'Unknown'}</div>
        <InmateCount />
      </div>
    </div>
  )
}

export default Disclaimer